exports = module.exports = require("../../../../../../../tyler-components-web-cli/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ":host{display:block}.tyl-expansion-panel__header{outline:0}.tyl-expansion-panel__header:hover{cursor:pointer}.tyl-expansion-panel__header tcw-open-icon{margin-left:auto}.tyl-expansion-panel__content{overflow:hidden}", ""]);
